export default (payload) => {
    const fetchTicketInformation = (payload) => {
        const { bearerToken, voucher, centerUid, searchTermType, searchTerm } = payload.value

        // Compose url
        const apiBaseUrl = `/api/parking/centers/${centerUid}/tickets/search/${searchTermType}/${searchTerm}`
        const apiUrl = voucher ? `${apiBaseUrl}?voucher=${voucher}` : apiBaseUrl

        // Define header
        const headers = {
            Authorization: `Bearer ${bearerToken.value}`
        }

        return $fetch(apiUrl, { headers })
    }

    // Computed queryKey - remains undefined until submit
    const queryKey = computed(() => {
        if (payload.value?.isSubmitTriggered && payload.value?.searchTerm && payload.value?.searchTermType) {
            return ['ticketInfo', payload.value.searchTermType, payload.value.searchTerm]
        }
        return []
    })

    return useFetchWithTanstackQuery({
        queryKey,
        queryFn: () => fetchTicketInformation(payload),
        storageType: null, // 'sessionStorage', // hmmm maybe not session
        preventFatalError: true, // Handle profile errors more specific
        options: {
            enabled: false,
            staleTime: 0,
            cacheTime: 0
        }
    })
}
